import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
} from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    IProcess,
    ModalResultType,
} from '@models';
import { ProcessService } from '@services';

import {
    BehaviorSubject,
    Observable,
} from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: './versions.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ProcessService],
})
export class ProcessVersionsModalComponent
    extends UiModalComponent<IProcess>
    implements OnInit {

    public formGroup!: FormGroup;
    public loading$ = new BehaviorSubject(false);
    public initialProcessVersion!: string;
    public isProcessEditAllowed$!: Observable<boolean>;

    private _fb = this._injector.get<FormBuilder>(FormBuilder);
    private _processService = this._injector.get<ProcessService>(ProcessService);

    ngOnInit() {
        const appState = this._injector.get<AppStateFacade>(AppStateFacade);
        this.isProcessEditAllowed$ = appState.user.permissions.isGranted('Processes.Edit');
        this.initialProcessVersion = this.context.data.processVersion;
        this.formGroup = this._fb.group({
            'arguments': [this.context.data.inputArguments || {}],
        });
    }

    public onClose() {
        const closeResult =
            this.initialProcessVersion !==
                this.context.data.processVersion ?
                {
                    type: ModalResultType.Update,
                    data: this.context.data,
                } :
                undefined;
        this._dialogRef.close(closeResult);
    }

    public onUpdate(processList: IProcess[]) {
        [this.context.data] = processList;
        this.formGroup.get('arguments')!
            .patchValue(this.context.data.inputArguments || {});
    }

    public updateParameters(inputArguments: Record<string, any>) {
        this.loading$.next(true);

        this._processService.patch(
            this.context.data.id, {
                inputArguments,
            }).pipe(
                finalize(
                    () => this.loading$.next(false),
                ),
            ).subscribe(() => {
                this._dialogRef.close({
                    type: ModalResultType.Update,
                    data: this.context.data,
                });
            });
    }
}
